<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="My Devices" pageTitle="Audio" />
            <AudioDevices />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import AudioDevices from '../Audio/AudioDevices'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'AudioPage',
    components: {
        MainHeader,
        PageTitle,
        AudioDevices,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>